import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  EntityConnectionTableStateKeyParams, toEntityConnectionTableKey
} from './entity-connection-table-key';
import { EntityConnectionsState, StateName } from './entity-connection.state';

export const selectEntityConnections = createFeatureSelector<EntityConnectionsState>(StateName);

export const selectEntityConnectionTableShowInactive = (props: EntityConnectionTableStateKeyParams) =>
  createSelector(selectEntityConnections, (state) => {
    const key = toEntityConnectionTableKey(props);
    if (!state.entity_connection_tables[key]) {
      return false;
    } else {
      return state.entity_connection_tables[key].includeInactive;
    }
  });
